import * as _ from 'lodash';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, FollowUpReportsActionCreators, IApplicationState, IFollowUpComplianceReportResponse } from "@nkr/store/index";
import { IFollowUpComplianceReport } from '@nkr/models/follow-up';
import { TableWrapper } from '../../styles';
import { FormControl, Well } from 'react-bootstrap';

interface IProps {
    centerId: number,
    isAdmin: boolean,
    isAdminLogin: boolean
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getComplianceReport: (centerId: number) => Promise<IFollowUpComplianceReportResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    data: IFollowUpComplianceReport[],
    centerFilter: number
}

class FollowUpComplianceReport extends Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        centerFilter: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting ready, one moment please...').then(() => {
            this.props.getComplianceReport(this.props.centerId).then(response => {
                if (response.data.success) {
                    this.setState({
                        data: response.data.results
                    });
                }

                this.props.hideLoading();
            })
        })
    }

    getCenters = () => {
        let list = this.state.data.map(x => {
            return { id: x.centerId, alias: x.centerAlias };
        });

        let centers = _.uniqBy(list, x => x.id);

        return _.sortBy(centers, item => item.alias);
    }

    getFilteredData = () => {
        return this.state.data.filter(x => {
            let centerFilter = this.state.centerFilter > 0 ? x.centerId == this.state.centerFilter : true;
            return centerFilter;
        })
    }

    handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerFilter: parseInt(e.currentTarget.value)
        });
    }

    render = () => {
        let centerList = this.getCenters();
        let data = this.getFilteredData();

        return (
            <div className={this.props.isAdminLogin ? 'container' : null}>
                {this.props.isAdmin && (
                    <Well bsSize='sm'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Center:</div>
                            <FormControl
                                componentClass='select'
                                value={this.state.centerFilter}
                                onChange={this.handleCenterChange}
                            >
                                <option value={0}>- All Centers -</option>
                                {centerList.map(center =>
                                    <option key={'ctr-' + center.id} value={center.id}>{center.alias}</option>
                                )}
                            </FormControl>
                        </div>
                    </Well>
                )}

                <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            {this.props.isAdmin && (
                                <th>Center</th>
                            )}

                            <th>Follow-Up</th>
                            <th>Total Follow-Ups</th>
                            <th>Completed Count</th>
                            <th>% Completed Late</th>
                            <th>Pending Count</th>
                            <th>% Pending Late</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) =>
                            <>
                                <tr key={'compliance-' + index}>
                                    {this.props.isAdmin && (
                                        <td>{item.centerAlias}</td>
                                    )}

                                    <td>{item.surveyInstanceDescription} {item.surveyInstance != 99 ? 'Follow-Up Survey' : 'Follow-Up Surveys'}</td>
                                    <td>{item.surveyCount}</td>
                                    <td>{item.completedCount}</td>
                                    <td>{item.percentCompletedLate}%</td>
                                    <td>{item.incompleteCount}</td>
                                    <td>{item.percentIncompleteLate}%</td>
                                </tr>

                                <tr key={'compliance-labs-' + index}>
                                    {this.props.isAdmin && (
                                        <td>{item.centerAlias}</td>
                                    )}
                                    
                                    <td>{item.surveyInstanceDescription} Follow-Up Labs</td>
                                    <td>{item.surveyCount}</td>
                                    <td>{item.labsCompletedCount}</td>
                                    <td>{item.labsPercentCompletedLate}%</td>
                                    <td>{item.labsIncompleteCount}</td>
                                    <td>{item.labsPercentIncompleteLate}%</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </TableWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getComplianceReport: (centerId) => {
            return dispatch(FollowUpReportsActionCreators.getComplianceReport(centerId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpComplianceReport);